import ic_stepper_completed from "./images/ic_stepper_completed.svg";
import ic_stepper_active from "./images/ic_stepper_active.png";
import ic_stepper_inactive from "./images/ic_stepper_inactive.png";
import ic_success from "./images/ic_success.png";
import ic_success_event from "./images/ic_success_event.png";
import ic_checkbox_checked from "./images/ic_checkbox_checked.svg";
import ic_checkbox_unchecked from "./images/ic_checkbox_unchecked.svg";
import ic_calender from "./images/ic_calender.svg";
import ic_datepicker from "./images/ic_datepicker.svg";
import ic_location from "./images/ic_location.svg";
import ic_notification_enabled from "./images/ic_notification_enabled.svg";
import ic_play from "./images/ic_play.png";
import ic_error_info from "./images/ic_error_info.png";
import ic_error_cross from "./images/ic_error_cross.png";
import ic_close from "./images/ic_close.png";
import ic_sekeron_logo from "./images/ic_sekeron_logo.png";
import ic_google from "./images/ic_google.png";
import ic_google_color from "./images/ic_google_color.png";
import ic_facebook from "./images/ic_facebook.png";
import ic_arrow_dropdown from "./images/ic_arrow_dropdown.png";
import ic_arrow_dropup from "./images/ic_arrow_dropup.png";
import ic_visibility from "./images/ic_visibility.png";
import ic_visibility_off from "./images/ic_visibility_off.png";
import ic_divider from "./images/ic_divider.png";
import ic_add from "./images/ic_add.png";
import ic_edit from "./images/ic_edit.svg";
import ic_checkbox_rounded_unchecked from "./images/ic_checkbox_rounded_unchecked.png";
import ic_checkbox_rounded_checked from "./images/ic_checkbox_rounded_checked.png";
import ic_dance from "./images/ic_dance.png";
import ic_swipedown from "./images/ic_swipedown.png";
import ic_artist from "./images/ic_artist.png";
import ic_intro_croussel from "./images/ic_intro_croussel.png";
import ic_growtogether from "./images/ic_growtogether.png";
import ic_sekeron from "./images/ic_sekeron.png";
import ic_search_header from "./images/ic_search_header.svg";
import ic_notification_inactive from "./images/ic_notification_inactive.svg";
import ic_notification_active from "./images/ic_notification_active.png";
import ic_chat_inactive from "./images/ic_chat_inactive.svg";
import ic_chat_cutom from "./images/ic_chat_cutom.png";
import ic_notification_custom from "./images/ic_notification_custom.png";
import ic_dashboard_inactive from "./images/ic_dashboard_inactive.svg";
import ic_dashboard_active from "./images/ic_dashboard_active.svg";
import ic_create_post_inactive from "./images/ic_create_post_inactive.svg";
import ic_create_post_active from "./images/ic_create_post_active.svg";
import ic_profile from "./images/ic_profile.svg";
import ic_profile_active from "./images/ic_profile_active.svg";
import ic_home_inactive from "./images/ic_home_inactive.svg";
import ic_home_active from "./images/ic_home_active.svg";
import ic_camera_active from "./images/ic_camera_active.svg";
import ic_camera_inactive from "./images/ic_camera_inactive.svg";
import ic_cancel from "./images/ic_cancel.svg";
import ic_delete from "./images/ic_delete.png";
import ic_hand from "./images/ic_hand.png";
import ic_audio_inactive from "./images/ic_audio_inactive.svg";
import ic_dash from "./images/ic_dash.png";
import ic_audio_active from "./images/ic_audio_active.svg";
import ic_image_gallery from "./images/ic_image_gallery.svg";
import ic_text_active from "./images/ic_text_active.svg";
import ic_text_inactive from "./images/ic_text_inactive.svg";
import ic_timer from "./images/ic_timer.svg";
import ic_upload from "./images/ic_upload.png";
import ic_video_inactive from "./images/ic_video_inactive.svg";
import ic_dropdownb from "./images/ic_dropdownb.png";
import ic_video_active from "./images/ic_video_active.svg";
import ic_dropup from "./images/ic_dropup.png";
import ic_dropdown from "./images/ic_dropdown.png";
import ic_up_dropdown from "./images/ic_up_dropdown.png";
import ic_voice_recorder from "./images/ic_voice_recorder.png";
import ic_grid from "./images/ic_grid.png";
import ic_voice_recording from "./images/ic_voice_recording.png";
import ic_play_video from "./images/ic_play_video.png";
import ic_pause_video from "./images/ic_pause_video.png";
import ic_mute from "./images/ic_mute.png";
import ic_unmute from "./images/ic_unmute.png";
import ic_voice_recorder_pause from "./images/ic_voice_recorder_pause.png";
import ic_loader from "./images/ic_loader.png";
import ic_pause from "./images/ic_pause.png";
import ic_indian_flag from "./images/ic_indian_flag.jpg";
import ic_more from "./images/ic_more.png";
import ic_admire_inactive from "./images/ic_admire_inactive.png";
import ic_favourite_active from "./images/ic_favourite_active.png";
import ic_comment_inactive from "./images/ic_comment_inactive.png";
import ic_send_inactive from "./images/ic_send_inactive.png";
import ic_favourite_inactive from "./images/ic_favourite_inactive.png";
import ic_right from "./images/ic_right.png";
import ic_left from "./images/ic_left.png";
import ic_previous from "./images/ic_previous.png";
import ic_white_close from "./images/ic_white_close.svg";
import ic_active_admire from "./images/ic_active_admire.svg";
import ic_checkedicon_blue from "./images/ic_checkedicon_blue.svg";
import ic_unchecked from "./images/ic_unchecked.svg";
import ic_add_artist from "./images/ic_add_artist.svg";
import ic_remove_artist from "./images/ic_remove_artist.svg";
import ic_forward from "./images/ic_forward.svg";
import ic_active_buzzer_notification from "./images/ic_active_buzzer_notification.svg";
import ic_inactive_buzzer_notification from "./images/ic_inactive_buzzer_notification.svg";
import ic_white_unchecked from "./images/ic_white_unchecked.svg";
import ic_checked_circle from "./images/ic_checked_circle.svg";
import ic_unchecked_circle from "./images/ic_unchecked_circle.svg";
import ic_new_post from "./images/ic_new_post.svg";
import ic_new_project from "./images/ic_new_project.png";
import ic_notification_post from "./images/ic_notification_post.svg";
import ic_notification_project from "./images/ic_notification_project.png";
import ic_pen from "./images/ic_pen.svg";
import ic_erase from "./images/ic_erase.svg";
import ic_full_screen from "./images/ic_full_screen.svg";
import ic_undo from "./images/ic_undo.svg";
import ic_redo from "./images/ic_redo.svg";
import ic_success_info from "./images/ic_success_info.svg";
import ic_profile_cver from "./images/ic_profile_cver.png";
import ic_dummy_profile from "./images/ic_dummy_profile.png";

import ic_artist_image from "./images/ic_artist_image.jpg";
import ic_artist_image_2 from "./images/ic_artist_image_2.jpg";
import ic_artist_image_3 from "./images/ic_artist_image_3.jpg";
import ic_artist_image_4 from "./images/ic_artist_image_4.jpg";
import ic_artist_image_5 from "./images/ic_artist_image_5.webp";
import ic_artist_image_6 from "./images/ic_artist_image_6.webp";
import ic_paranoma_1 from "./images/ic_paranoma_1.jpg";
import ic_paranoma_2 from "./images/ic_paranoma_2.jpg";

import ic_image_cover from "./images/ic_coverphoto.png";
import ic_avatar from "./images/ic_avatar.png";
import ic_icon_paint_brush from "./images/ic_paint-brush.png";
import ic_icon_eye_mask from "./images/ic_eye-mask.png";
import ic_icon_guitar from "./images/ic_guitar.png";
import ic_icon_admiration from "./images/ic_admiration.png";
import ic_icon_followers from "./images/ic_followers.png";
import ic_icon_following from "./images/ic_following.png";
import ic_imgNature from "./images/ic_nature.png";
import ic_posts_working from "./images/ic_sqaure_working.jpg";
import ic_posts_tiger from "./images/ic_square_tiger.jpg";
import ic_posts_relax from "./images/ic_square_seeingwaterfall.jpg";
import ic_posts_falls from "./images/ic_square_waterfalls.jpg";
import ic_expand_icon from "./images/ic_icon_expand.png";
import ic_to_expand_icon from "./images/ic_icon_to_expand.png";
import ic_city_icon from "./images/ic_icon_city.png";
import ic_email_icon from "./images/ic_icon_email.png";
import ic_group_icon from "./images/ic_icon_group.png";
import ic_facebook_icon from "./images/ic_icon_facebook.png";
import ic_instagram_icon from "./images/ic_icon_instagram.png";
import ic_flag_icon from "./images/ic_icon_flag.png";
import ic_phone_call_icon from "./images/ic_icon_phone_call.png";
import ic_pinterest_icon from "./images/ic_icon_pinterest_circular.png";
import ic_youtube_icon from "./images/ic_icon_youtube.png";
import ic_suitcase_icon from "./images/ic_icon_suitcase.png";
import ic_search_icon from "./images/ic_icon_search.png";
import ic_close_icon from "./images/ic_icon_close.png";
import ic_friend_one from "./images/ic_friend_one.jpeg";
import ic_friend_two from "./images/ic_friend_two.jpeg";
import ic_colorpicker from "./images/ic_colorpicker.png";
import ic_date_picker from "./images/ic_date_picker.svg";
import ic_filter from "./images/ic_filter.svg";
import ic_notification_events from "./images/ic_notification_events.svg";
import ic_star from "./images/ic_star.svg";
import ic_default_cover_image from "./images/ic_default_cover_image.svg";
import ic_default_profile_image from "./images/ic_default_profile_image.svg";
import ic_school from "./images/ic_school.svg";
import ic_work from "./images/ic_work.svg";
import ic_facebooks from "./images/ic_facebook.svg";
import ic_instagram from "./images/ic_instagram.svg";
import ic_youtube from "./images/ic_youtube.svg";
import ic_pinterest from "./images/ic_pinterest.svg";
import ic_country from "./images/ic_country.svg";
import ic_city from "./images/ic_city.png";
import ic_edit_profile from "./images/ic_edit_profile.svg";
import ic_blue_camera from "./images/ic_blue_camera.svg";
import ic_right_arrow from "./images/ic_right_arrow.svg";
import ic_radio_checked from "./images/ic_radio_checked.svg";
import ic_radio_unchecked from "./images/ic_radio_unchecked.svg";
import ic_dashboard_my_calender from "./images/ic_dashboard_my_calender.svg";
import ic_dashboard_my_projects from "./images/ic_dashboard_my_projects.svg";
import ic_dashboard_collaborations from "./images/ic_dashboard_collaborations.svg";
import ic_dashboard_explore_blogs_bg from "./images/ic_dashboard_explore_blogs_bg.svg";
import ic_dashboard_explore_projects_bg from "./images/ic_dashboard_explore_projects_bg.svg";
import ic_puzzle from "./images/ic_puzzle.svg";
import ic_project_gallery from "./images/ic_project_gallery.svg";
import ic_project_chat from "./images/ic_project_chat.svg";
import ic_schedule_meeting from "./images/ic_schedule_meeting.svg";
import ic_project_task from "./images/ic_project_task.svg";
import ic_contract from "./images/ic_contract.svg";
import ic_project_calender from "./images/ic_project_calender.svg";
import ic_scrible_whiteboard from "./images/ic_scrible_whiteboard.svg";
import ic_project_success_icon from "./images/ic_project_success_icon.svg";
import ic_accept_request from "./images/ic_accept_request.svg";
import ic_decline_request from "./images/ic_decline_request.svg";
import ic_google_meet from "./images/ic_google_meet.png";
import ic_skype from "./images/ic_skype.svg";
import ic_zoom_meeting from "./images/ic_zoom_meeting.svg";
import ic_ms_teams from "./images/ic_ms_teams.svg";
import ic_accept from "./images/ic_accept.svg";
import ic_destination from "./images/ic_destination.svg";
import ic_current_location from "./images/ic_current_location.svg";
import ic_dubble_tik from "./images/ic_dubble_tik.svg";
import ic_blue_tik from "./images/ic_blue_tik.svg";
import ic_single_tik from "./images/ic_single_tik.svg";
import ic_emoji from "./images/ic_emoji.svg";
import ic_project_media from "./images/ic_project_media.svg";
import ic_send_message from "./images/ic_send_message.svg";
import ic_white_play from "./images/ic_white_play.svg";
import ic_active_star from "./images/ic_active_star.svg";
import ic_inactive_star from "./images/ic_inactive_star.svg";
import ic_checked_green_circle from "./images/ic_checked_green_circle.svg";
import ic_unchecked_green_circle from "./images/ic_unchecked_green_circle.svg";
import in_normal_cancel from "./images/in_normal_cancel.png";
import ic_success_admired from "./images/ic_success_admired.svg";

// Help and support
import ic_profile_security from "./images/ic_profile_security.svg";
import ic_help from "./images/ic_help.svg";
import ic_settings_notifications from "./images/ic_settings_notifications.svg";
import ic_key from "./images/ic_key.svg";
import ic_delete_acount from "./images/ic_delete_acount.svg";
import ic_loggedin_devices from "./images/ic_loggedin_devices.svg";

import ic_active_search from "./images/ic_active_search.svg";
import ic_upcoming from "./images/ic_upcoming.svg";
import ic_completed from "./images/ic_completed.svg";
import ic_ongoing from "./images/ic_ongoing.svg";
import ic_snackbar_success from "./images/ic_snackbar_success.svg";
import ic_snackbar_failure from "./images/ic_snackbar_failure.svg";
import ic_fb from "./images/ic_fb.svg";
import ic_messenger from "./images/ic_messenger.svg";
import ic_twitter from "./images/ic_twitter.svg";
import ic_copy_link from "./images/ic_copy_link.svg";
import ic_gallery from "./images/ic_gallery.svg";
import ic_collge_studying from "./images/ic_collge_studying.svg";
import ic_sekeron_original_logo from "./images/ic_sekeron_original_logo.svg";

// Landing page related images
import ic_header_logo from "./landing-page-images/header-logo.webp";
import ic_grid_bg from "./landing-page-images/grid.svg";

import ic_i_phone_12_pro from "./landing-page-images/i-phone-12-pro@3x.webp";
import ic_macbook_pro_mockup from "./landing-page-images/macbook-pro-mockup.webp";
import sekeron_bg_logo from "./landing-page-images/sekeron_bg_logo.webp";
import ic_qr_code from "./landing-page-images/QR-code.webp";
import ic_hero_section_vector from "./landing-page-images/hero-section-vector.webp";
import ic_exposure_1 from "./landing-page-images/our-exposure-images/exposure-1.webp";
import ic_exposure_2 from "./landing-page-images/our-exposure-images/exposure-2.svg";
import ic_exposure_3 from "./landing-page-images/our-exposure-images/exposure-3.svg";
import ic_exposure_4 from "./landing-page-images/our-exposure-images/exposure-4.svg";
import ic_exposure_5 from "./landing-page-images/our-exposure-images/exposure-5.svg";
import ic_create from "./landing-page-images/blogs-images/create.svg";
import ic_connect from "./landing-page-images/blogs-images/connect.svg";
import ic_abstract_shape from "./landing-page-images/blogs-images/abstract-shape.svg";
import ic_explore from "./landing-page-images/blogs-images/explore.svg";
import ic_puzzle_manage from "./landing-page-images/blogs-images/puzzle.svg";
import ic_inspire from "./landing-page-images/blogs-images/inspire.svg";
import ic_platform_1 from "./landing-page-images/platform-images/group-55@3x.webp";
import ic_platform_2 from "./landing-page-images/platform-images/group-54@3x.webp";
import ic_platform_3 from "./landing-page-images/platform-images/group-53@3x.webp";
import ic_platform_4 from "./landing-page-images/platform-images/group-52@3x.webp";
import ic_platform_5 from "./landing-page-images/platform-images/group-51@3x.webp";
import ic_platform_6 from "./landing-page-images/platform-images/group-50@3x.webp";
import ic_platform_7 from "./landing-page-images/platform-images/group-49@3x.webp";
import ic_app_store from "./landing-page-images/ic_app_store.webp";
import ic_line from "./images/ic_line.png";
import ic_google_play from "./landing-page-images/ic_google_play.webp";
import gif_sekeron_logo from "./images/gif_sekeron_logo.gif";
import ic_location_pin from "./images/ic_location_pin.svg";
import ic_current_map_location from "./images/ic_current_map_location.svg";
import ic_search from "./images/ic_search.svg";
import ic_whatsapp from "./images/ic_whatsapp.png";
import ic_gmail from "./images/ic_gmail.png";
import ic_facebook_social_icon from "./images/ic_facebook_social_icon.png";
import ic_link from "./images/ic_link.png";
import ic_linkedin from "./images/ic_linkedin.png";
import ic_heart_fill from "./images/ic_heart_fill.png";
import ic_love from "./images/ic_love.png";
import ic_calendar_icon from "./images/ic_calendar_icon.png";
import ic_download from "./images/ic_download.svg";

//default images (null states)
import ic_tree from "./images/ic_tree.jpg";
import ic_default_groupIcon from "./images/ic_default_groupIcon.png";
import ic_blocked_users from "./images/NoBlockedUsers.png";
import ic_explore_no_records from "./images/explore_no_results.png";
import ic_collab_invite from "./images/collaborator_invitation.png";
import ic_bookmarks from "./images/NoBookmarks.png";
import ic_comments from "./images/NoComments.png";
import ic_notifications from "./images/NoNotifications.png";
import ic_followers from "./images/NoFollowers.png";
import ic_following from "./images/NoFollowing.png";
import ic_Meetings from "./images/NoMeetings.png";
import ic_Tasks from "./images/NoTasks.png";
import ic_profile_posts from "./images/No_posts_profile.png";
import ic_mutuals from "./images/NoMutuals.png";
import ic_profile_projects from "./images/Profile_projects_myprojects.png";
import ic_profile_collab from "./images/profile_projects_collaboration.png";
import ic_project_collaborators from "./images/project_collaborators.png";
import ic_project_invitees from "./images/Project_initiator_invitees.png";
import ic_project_requests from "./images/project_initiator_requests.png";
import ic_profile_media from "./images/Project_media_gallery.png";
import ic_no_projects from "./images/no_projects.png";
import ic_no_collab from "./images/no_collab.png";

import ic_post_loading from "./images/post_loading.png";
import ic_sekeron_app from "./images/SekeronApp.jpg";
import ic_eye from "./images/ic_eye.png";

// default images done

import ic_sound from "./images/sound.png";
import ic_docs from "./images/docs.png";
import ic_mic from "./images/mic.png";
import ic_camera from "./images/camera.png";
import ic_video_camera from "./images/video-camera.png";
import ic_chat_background from "./images/chatBackground.png";

// carousel images
import carousel1 from "./images/carousel1.png";
import carousel2 from "./images/carousel2.png";
import carousel3 from "./images/carousel3.png";
import MobileCarousel1 from "./images/MobileCarousel1.png";
import MobileCarousel2 from "./images/MobileCarousel2.png";
import MobileCarousel3 from "./images/MobileCarousel3.png";

import ig_group7 from "./info-graphics/assets/Group7.png";
import ig_01 from "./info-graphics/assets/01.png";
import ig_02 from "./info-graphics/assets/02.png";
import ig_03 from "./info-graphics/assets/03.png";
import ig_04 from "./info-graphics/assets/04.png";
import ig_05 from "./info-graphics/assets/05.png";
import ig_06 from "./info-graphics/assets/06.png";
import equal from "./info-graphics/assets/equal.png";
import collabspace from "./info-graphics/assets/collabspace.png";
import coowner from "./info-graphics/assets/coowner.png";
import unequal from "./info-graphics/assets/unequal.png";
import counequal from "./info-graphics/assets/counequal.png";
import ig_screen2_01 from "./info-graphics/assets/screen2/01.png";
import ig_screen2_06 from "./info-graphics/assets/screen2/06.png";
import ig_screen3_01 from "./info-graphics/assets/screen3/01.png";
import ig_screen3_02 from "./info-graphics/assets/screen3/02.png";
import ig_screen3_03 from "./info-graphics/assets/screen3/03.png";
import ig_screen3_04 from "./info-graphics/assets/screen3/04.png";
import ig_screen3_05 from "./info-graphics/assets/screen3/05.png";
import ig_screen3_06 from "./info-graphics/assets/screen3/06.png";
import ig_screen3_07 from "./info-graphics/assets/screen3/07.png";
import ig_screen3_08 from "./info-graphics/assets/screen3/08.png";

import under_maintainance from "./images/under maintainance.png";

import calendar from "./images/calendar.png";
import link from "./images/link.png";
import ic_info from "./images/ic_info.png";

const ImageAssets = {
  ic_contract,
  ic_stepper_active,
  ic_stepper_inactive,
  ic_stepper_completed,
  ic_success,
  ic_checkbox_checked,
  ic_checkbox_unchecked,
  ic_calender,
  ic_datepicker,
  ic_location,
  ic_notification_enabled,
  ic_play,
  ic_error_info,
  ic_error_cross,
  ic_close,
  ic_sekeron_logo,
  ic_facebook,
  ic_google,
  ic_google_color,
  ic_dash,
  ic_arrow_dropdown,
  ic_dropdownb,
  ic_up_dropdown,
  ic_arrow_dropup,
  ic_visibility,
  ic_visibility_off,
  ic_line,
  ic_divider,
  ic_add,
  ic_edit,
  ic_radio_unchecked,
  ic_radio_checked,
  ic_swipedown,
  ic_dance,
  ic_success_event,
  ic_artist,
  ic_intro_croussel,
  ic_growtogether,
  ic_sekeron,
  ic_search_header,
  ic_home_active,
  ic_love,
  ic_heart_fill,
  ic_camera_active,
  ic_cancel,
  ic_delete,
  ic_hand,
  ic_image_gallery,
  ic_timer,
  ic_upload,
  ic_voice_recorder,
  ic_loader,
  ic_dropup,
  ic_dropdown,
  ic_grid,
  ic_text_active,
  ic_dashboard_active,

  ic_create_post_active,
  ic_audio_active,
  ic_video_active,
  ic_unmute,
  ic_mute,
  ic_play_video,
  ic_pause,
  ic_voice_recorder_pause,
  ic_pause_video,
  ic_audio_inactive,
  ic_camera_inactive,
  ic_home_inactive,
  ic_profile,
  ic_profile_active,
  ic_create_post_inactive,
  ic_dashboard_inactive,
  ic_chat_inactive,
  ic_chat_cutom,
  ic_notification_custom,
  ic_notification_active,
  ic_notification_inactive,
  ic_voice_recording,
  ic_video_inactive,
  ic_text_inactive,
  ic_checkedicon_blue,
  ic_unchecked,
  ic_add_artist,
  ic_remove_artist,
  ic_date_picker,
  ic_calendar_icon,
  ic_download,
  ic_filter,
  ic_active_buzzer_notification,
  ic_inactive_buzzer_notification,
  ic_white_unchecked,
  ic_unchecked_circle,
  ic_checked_circle,
  ic_new_post,
  ic_notification_post,
  ic_notification_events,
  ic_notification_project,
  ic_new_project,
  ic_star,
  ic_default_profile_image,
  ic_default_cover_image,
  ic_work,
  ic_school,
  ic_facebooks,
  ic_instagram,
  ic_whatsapp,
  ic_gmail,
  ic_facebook_social_icon,
  ic_youtube,
  ic_pinterest,
  ic_country,
  ic_city,
  ic_edit_profile,
  ic_blue_camera,
  ic_profile_cver,
  ic_dummy_profile,
  ic_dashboard_explore_projects_bg,
  ic_dashboard_explore_blogs_bg,
  ic_dashboard_collaborations,
  ic_dashboard_my_projects,
  ic_dashboard_my_calender,
  ic_project_success_icon,
  ic_avatar,
  ic_image_cover,
  ic_icon_paint_brush,
  ic_icon_eye_mask,
  ic_icon_guitar,
  ic_icon_admiration,
  ic_icon_followers,
  ic_icon_following,
  ic_imgNature,
  ic_posts_working,
  ic_posts_tiger,
  ic_posts_relax,
  ic_posts_falls,
  ic_expand_icon,
  ic_city_icon,
  ic_email_icon,
  ic_group_icon,
  ic_facebook_icon,
  ic_instagram_icon,
  ic_flag_icon,
  ic_phone_call_icon,
  ic_pinterest_icon,
  ic_youtube_icon,
  ic_suitcase_icon,
  ic_to_expand_icon,
  ic_search_icon,
  ic_close_icon,
  ic_friend_one,
  ic_friend_two,
  ic_more,
  ic_send_inactive,
  ic_comment_inactive,
  ic_admire_inactive,
  ic_favourite_active,
  ic_favourite_inactive,
  ic_left,
  ic_right,
  ic_previous,
  ic_white_close,
  ic_active_admire,
  ic_colorpicker,
  ic_forward,
  ic_destination,
  ic_current_location,
  ic_dubble_tik,
  ic_blue_tik,
  ic_single_tik,
  ic_emoji,
  ic_project_media,
  ic_send_message,
  ic_white_play,
  ic_project_gallery,
  ic_project_chat,
  ic_schedule_meeting,
  ic_project_task,
  ic_project_calender,
  ic_scrible_whiteboard,
  ic_active_star,
  ic_inactive_star,
  ic_checked_green_circle,
  ic_unchecked_green_circle,
  in_normal_cancel,
  ic_success_admired,
  ic_active_search,
  ic_upcoming,
  ic_completed,
  ic_ongoing,
  ic_snackbar_success,
  ic_snackbar_failure,

  under_maintainance,

  calendar,
  link,
  ic_info,

  ic_indian_flag,
  ic_artist_image,
  ic_artist_image_2,
  ic_artist_image_3,
  ic_artist_image_4,
  ic_artist_image_5,
  ic_artist_image_6,
  ic_paranoma_1,
  ic_paranoma_2,

  ic_full_screen,
  ic_erase,
  ic_pen,
  ic_redo,
  ic_undo,
  ic_success_info,
  ic_right_arrow,
  ic_checkbox_rounded_checked,
  ic_checkbox_rounded_unchecked,
  ic_puzzle,
  ic_decline_request,
  ic_accept_request,
  ic_ms_teams,
  ic_zoom_meeting,
  ic_skype,
  ic_google_meet,
  ic_accept,
  ic_profile_security,
  ic_settings_notifications,
  ic_help,
  ic_loggedin_devices,
  ic_delete_acount,
  ic_key,
  ic_fb,
  ic_messenger,
  ic_twitter,
  ic_copy_link,
  ic_link,
  ic_linkedin,
  ic_gallery,
  ic_collge_studying,

  ic_header_logo,
  ic_grid_bg,
  ic_qr_code,
  ic_i_phone_12_pro,
  ic_macbook_pro_mockup,
  sekeron_bg_logo,
  ic_hero_section_vector,
  ic_exposure_1,
  ic_exposure_2,
  ic_exposure_3,
  ic_exposure_4,
  ic_exposure_5,
  ic_create,
  ic_connect,
  ic_abstract_shape,
  ic_explore,
  ic_puzzle_manage,
  ic_inspire,
  ic_platform_1,
  ic_platform_2,
  ic_platform_3,
  ic_platform_4,
  ic_platform_5,
  ic_platform_6,
  ic_platform_7,
  ic_app_store,
  ic_google_play,
  gif_sekeron_logo,
  ic_sekeron_original_logo,
  ic_location_pin,
  ic_current_map_location,
  ic_search,
  ic_tree,
  ic_default_groupIcon,
  ic_blocked_users,
  ic_explore_no_records,
  ic_collab_invite,
  ic_bookmarks,
  ic_comments,
  ic_notifications,
  ic_followers,
  ic_following,
  ic_Meetings,
  ic_Tasks,
  ic_profile_posts,
  ic_mutuals,
  ic_profile_projects,
  ic_profile_collab,
  ic_project_collaborators,
  ic_project_invitees,
  ic_project_requests,
  ic_profile_media,

  carousel1,
  carousel2,
  carousel3,

  MobileCarousel1,
  MobileCarousel2,
  MobileCarousel3,

  ig_group7,
  ig_01,
  ig_02,
  ig_03,
  ig_04,
  ig_05,
  ig_06,
  equal,
  coowner,
  unequal,
  counequal,
  collabspace,

  ig_screen2_01,
  ig_screen2_06,

  ig_screen3_01,
  ig_screen3_02,
  ig_screen3_03,
  ig_screen3_04,
  ig_screen3_05,
  ig_screen3_06,
  ig_screen3_07,
  ig_screen3_08,

  ic_sound,
  ic_docs,
  ic_mic,
  ic_camera,
  ic_video_camera,
  ic_chat_background,

  ic_no_projects,
  ic_no_collab,
  ic_post_loading,
  ic_sekeron_app,
  ic_eye
};

export default ImageAssets;
